<template>
  <div class="wrapper">
    <reportHeader></reportHeader>
    <transition enter-active-class="animated bounceIn  " leave-active-class="animated bounceOut">
      <article class="calendar-body"
               v-show="showCalendar"
               @touchstart="calendarTouchStart"
               @touchmove="calendarTouchMove"
               @touchend="calendarTouchEnd"
    >
      <header class="head-title">
        <a href="javascript: void(0)" class="icon-arrow arrow-left with_arrow" @click="adjacentMonth('prev')"></a>
        <span class="date">{{this.calendar.getMonthHead()}}</span>
        <a href="javascript: void(0)" :class="['icon-arrow', 'arrow-right', 'with_arrow', { disabled: !calendar.canGetNext() }]" @click="adjacentMonth('next')"></a>
      </header>
      <div class="week">
        <span v-for="item in week" :key="item">{{item}}</span>
      </div>
      <ul class="days">
        <li class="day"
            v-for="(date, i) in calendar.days"
            :key="date.day"
            :style="{ marginLeft: i === 0 ? `${calendar.frontSpace * 1.14}rem` : '0' }"
            @click="handleDayClick(date)"
        >
          <span :class="['item', {reported: date.state === 'reported'}, {'can-report': date.state === 'canReport'}]">
            {{+date.day}}
          </span>
        </li>
      </ul>
      <button class="total-data" @click="handleMonthClick">月汇总数据</button>
    </article>
    </transition>
    <footer class="foot">
      <span class="reported">已上报</span>
      <span class="can-report">未上报</span>
      <span class="other">点击日期可查看当天数据</span>
    </footer>
  </div>
</template>

<script>
  import Calendar from './calendar'
  import head from '../../../commponents/head/index.vue'

  export default {
    data() {
      return {
        calendar: new Calendar(),
        showCalendar: true
      }
    },
    components: {
      reportHeader: head
    },
    created() {
      this.week = ['日', '一', '二', '三', '四', '五', '六']
      // 获取日历数据
      this.getCalendarData()
    },
    beforeDestroy() {
      this.timer && clearTimeout(this.timer)
    },
    methods: {
      async getCalendarData() {
        const { data } = await this.$rest.dataReport.getCalendarData(this.calendar.getYM())
        this.calendar.days = this.calendar.days.map((day) => {
          if (data && data.date_info && data.date_info[day.dateStr] === 1) {
            return { ...day, state: 'reported' }
          }
          return day
        })
      },
      adjacentMonth(direction) {
        // 如果现在展示的正是当前页，那就不让他往下个月走了
        if (!this.calendar.canGetNext() && direction === 'next') return
        this.showCalendar = false
        const queryParams = direction === 'prev'
          ? this.calendar.getPrevDate()
          : direction === 'next'
            ? this.calendar.getNextDate()
            : ''
        if (queryParams === '') return
        this.timer = setTimeout(() => {
          this.showCalendar = true
          this.calendar = new Calendar(new Date(+queryParams.year, +queryParams.month, 0))
          // 动画结束后更新当前日历对象
          this.getCalendarData()
        }, 100)
      },
      handleDayClick({ year, month, day, state }) {
        if (state === 'future') return
        if (state === 'canReport') {
          this.$router.push({
            path: 'editReport',
            query: { year, month, day }
          })
        }
        if (state === 'reported') {
          this.$router.push({
            path: 'reportDetail',
            query: { year, month, day }
          })
        }
      },
      handleMonthClick() {
        this.$router.push({
          path: 'reportDetail',
          query: this.calendar.getYM()
        })
      },
      calendarTouchStart(e) {
        this.touch = {}
        this.touch.initiated = true
        const { pageX, pageY } = e.touches[0]
        this.touch.startX = pageX
        this.touch.startY = pageY
      },
      calendarTouchMove(e) {
        if (!this.touch.initiated) {
          return
        }
        const touch = e.touches[0]
        const deltaX = touch.pageX - this.touch.startX
        const deltaY = touch.pageY - this.touch.startY
        // 横向移动位移要大于纵向移动位移
        if (Math.abs(deltaY) > Math.abs(deltaX)) return
        this.touch.percent = Math.abs(deltaX / window.innerWidth)
        this.touch.direction = deltaX < 0 ? 'next' : 'prev'
      },
      calendarTouchEnd() {
        // 移动距离大于屏幕宽度的 1/5
        if (this.touch.percent > 0.2) {
          this.adjacentMonth(this.touch.direction)
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .wrapper {
    /*display: flex;*/
    /*flex-direction: column;*/
    /*align-items: center;*/

    .calendar-body {
      position: relative;
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 9.3rem;
      /*height: 13rem;*/
      margin: -2.3rem auto 0;
      padding: .6rem;
      background-color: #fff;
      box-shadow: 0 0 0.3rem 0 rgba(0, 0, 0, 0.2);
      border-radius: 0.6rem;

      .head-title {
        display: flex;
        justify-content: space-between;
        width: 6.3rem;
        height: .6rem;
        margin-bottom: .6rem;

        .icon-arrow {
          position: relative;
          /*display: flex;*/
          /*align-items: center;*/
          /*justify-content: center;*/
          width: .6rem;
          height: .6rem;
          border-radius: .3rem;
          background-color: #15a1ff;

          &::after {
            position: absolute;
            left: .1rem;
            top: 50%;
            margin-top: -.1rem;
            border-color: #fff;
          }
        }
        .arrow-left::after {
          transform: translateX(.05rem) rotate(225deg);

        }
        .arrow-right::after {
          transform: translateX(-.05rem) rotate(45deg);
        }

        .disabled {
          background-color: #ccc;
        }

        .date {
          font-size: 0.4rem;
          color: #333333;
        }
      }

      .week {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 7.98rem;
        height: 0.9rem;
        margin-bottom: .3rem;
        background-color: rgba(21, 161, 255, 0.1);
        font-size: 18px;
        color: #333333;
      }

      .days {
        display: flex;
        flex-flow: row wrap;
        width: 7.98rem;
        overflow-y: auto;
        /*justify-content: space-around;*/
        /*align-items: center;*/

        .day {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 1.14rem;
          height: 1.4rem;
          font-size: 16px;
          /*background-color: #ccc;*/

          .item {
            /*display: flex;*/
            /*justify-content: space-around;*/
            /*align-items: center;*/
            width: 0.8rem;
            height: 0.8rem;
            line-height: .8rem;
            text-align: center;
            border-radius: 50%;
            font-family: PingFangSC-Regular;
          }

          .reported {
            background-color: #15a1ff;
            color: #fff;
          }

          .can-report {
            border: solid 1px #15a1ff;
          }
        }
      }

      .total-data {
        width: 5.3rem;
        height: 1.1rem;
        background-color: #fafdff;
        border-radius: 3px;
        border: solid 1px #15a1ff;
        margin-top: .6rem;
        margin-bottom: .3rem;
        font-size: 15px;
        color: #15a1ff;
      }
    }

    .foot {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.5rem;
      line-height: 0.5rem;
      margin-top: .5rem;
      margin-bottom: 2.7rem;
      font-size: 12px;
      color: #666;

      span {
        display: flex;
        align-items: center;
      }

      .reported {
        margin-left: 1rem;
        margin-right: .5rem;

        &::before {
          content: '';
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #15a1ff;
          margin-right: 7px;
        }
      }

      .can-report {
        margin-right: .5rem;

        &::before {
          content: '';
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #fff;
          border: solid 1px #15a1ff;
          margin-right: 7px;
        }
      }

      .other {
      }
    }
  }

  @keyframes bounceIn {
    from,
    20%,
    40%,
    60%,
    80%,
    to {
      -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      -webkit-transform: scale3d(0.3, 0.3, 0.3);
      transform: scale3d(0.3, 0.3, 0.3);
    }

    30% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1);
      transform: scale3d(1.1, 1.1, 1.1);
    }

    70% {
      -webkit-transform: scale3d(0.97, 0.97, 0.97);
      transform: scale3d(0.97, 0.97, 0.97);
    }

    to {
      opacity: 1;
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  .bounceIn {
    -webkit-animation-duration: .6s;
    animation-duration: .6s;
    -webkit-animation-name: bounceIn;
    animation-name: bounceIn;
  }

  @keyframes bounceOut {
    20% {
      -webkit-transform: scale3d(0.9, 0.9, 0.9);
      transform: scale3d(0.9, 0.9, 0.9);
    }

    50%,
    55% {
      opacity: 1;
      -webkit-transform: scale3d(1.1, 1.1, 1.1);
      transform: scale3d(1.1, 1.1, 1.1);
    }

    to {
      opacity: 0;
      -webkit-transform: scale3d(0.3, 0.3, 0.3);
      transform: scale3d(0.3, 0.3, 0.3);
    }
  }

  .bounceOut {
    -webkit-animation-duration: .6s;
    animation-duration: .6s;
    -webkit-animation-name: bounceOut;
    animation-name: bounceOut;
  }
</style>



// WEBPACK FOOTER //
// index.vue?f52e2658